import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable } from 'rxjs';

import { BoundType, LocationInfoMap } from '@fcom/dapi';
import { FinnairBoundItem, FinnairItineraryItemFlight, FinnairPassengerItem } from '@fcom/dapi/api/models';
import { SelectionPhase } from '@fcom/common/interfaces/booking';
import { ButtonSize, ButtonTheme } from '@fcom/ui-components';

import { getTails, isByBusOnly } from '../../../../utils/common-booking.utils';

const MAX_EXEC_TIMES = 20;

@Component({
  selector: 'fin-ancillary-flight-bound-selector',
  templateUrl: 'ancillary-flight-bound-selector.component.html',
  styleUrls: ['ancillary-flight-bound-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AncillaryFlightBoundSelectorComponent implements OnInit {
  readonly BoundType = BoundType;
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly SelectionPhase = SelectionPhase;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() showFlightCard$: Observable<boolean>;

  @Input()
  boundsOrFlights: (FinnairBoundItem | FinnairItineraryItemFlight)[];

  @Input()
  activeBoundIndex = 0;

  @Input()
  locations: LocationInfoMap;

  @Input()
  passengers: FinnairPassengerItem[];

  @Input()
  focusOnDetails$: Observable<boolean>;

  @Output()
  selectIndex: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  viewDetails: EventEmitter<void> = new EventEmitter<void>();

  tails: { [boundOrFlightId: string]: string[] };
  isBusOnlyConnections: { [boundOrFlightId: string]: boolean };

  ngOnInit(): void {
    this.tails = this.boundsOrFlights.reduce((all, boundOrFlight) => {
      all[boundOrFlight.id] = getTails(boundOrFlight);
      return all;
    }, {});

    this.isBusOnlyConnections = this.boundsOrFlights.reduce((all, boundOrFlight) => {
      all[boundOrFlight.id] = isByBusOnly(boundOrFlight);
      return all;
    }, {});
  }

  onChangeFlightBound(index: number, addition: number, execTimes = 0): void {
    const indexToGo =
      index < 0 ? this.boundsOrFlights.length - 1 : index <= this.boundsOrFlights.length - 1 ? index : 0;
    const boundOrFlight = this.boundsOrFlights[indexToGo];
    if (boundOrFlight) {
      this.selectIndex.emit(indexToGo);
      return;
    }

    if (execTimes < MAX_EXEC_TIMES) {
      this.onChangeFlightBound(indexToGo + addition, addition, execTimes + 1);
    }
  }
}
